// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import Vant from 'vant';
import 'vant/lib/index.css';
import animated from 'animate.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VueI18n from 'vue-i18n';
import VueClipboard from 'vue-clipboard2'
 

Vue.use(VueI18n)
Vue.use(VueAwesomeSwiper)
Vue.use(animated)
Vue.use(Vant);
Vue.use(Vuetify)
Vue.use(VueClipboard)
Vue.config.productionTip = false
const opts = {
  icons: {
    iconfont: 'mdiSvg',
  },
}

export default new Vuetify(opts)

const i18n = new VueI18n({
  locale: 'en-us',    // 语言标识, 通过切换locale的值来实现语言切换,this.$i18n.locale
  messages: {
    'zh-cn': require('./common/lang/zh'),   // 中文语言包
    'en-us': require('./common/lang/en'), // 英文语言包
    'zh-hk': require('./common/lang/tw'),   // 繁体语言包
    'jp': require('./common/lang/jp') ,   // 日语语言包
    'ko': require('./common/lang/ko') ,   // 韩语语言包
    'sp': require('./common/lang/sp') ,   // 西班牙语言包
    'ge': require('./common/lang/ge') ,   // 德语语言包
    'pt': require('./common/lang/pt') ,   // 葡萄牙
    'fr': require('./common/lang/fr') , // 法语
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  vuetify: new Vuetify(),
  i18n,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js